"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("g", {
      children: (0, jsx_runtime_1.jsx)("path", {
        d: "M3.70113 1.21923C3.18831 1.54649 2.8265 2.06406 2.69529 2.65809C2.56408 3.25212 2.67422 3.87393 3.00149 4.38675C3.05426 4.48442 3.11406 4.57812 3.18041 4.66712C0.920474 7.26577 0.52436 11.1648 2.48633 14.2392L6.18816 20.0399L5.48852 23.2074L6.1055 24.1742L23.5077 13.0687L22.8908 12.1019L19.7232 11.4023L16.0214 5.60155C14.0594 2.52715 10.3564 1.24413 7.04758 2.19923C6.9948 2.10157 6.935 2.00787 6.86865 1.91887C6.54139 1.40605 6.02382 1.04424 5.42979 0.913029C4.83576 0.781821 4.21394 0.891963 3.70113 1.21923ZM13.49 20.8222C13.8173 21.335 14.3348 21.6968 14.9289 21.828C15.5229 21.9593 16.1447 21.8491 16.6575 21.5219C17.1704 21.1946 17.5322 20.677 17.6634 20.083C17.7946 19.489 17.6844 18.8671 17.3572 18.3543L13.49 20.8222Z",
        fill: "currentColor"
      })
    })
  });
};

exports.default = Icon;